
import { Component, Vue } from 'vue-property-decorator'

import BaseButtons from '@/components/admin/BaseButtons.vue'
import RallyChallengeChooser from '@/components/admin/RallyChallengeChooser.vue'
import ChallengeStatistics from '@/components/admin/ChallengeStatistics.vue'
import RallyPictureChooser from '@/components/admin/RallyPictureChooser.vue'
import RallyRoundDefaultTeamlogoChooser from '@/components/admin/RallyRoundDefaultTeamlogoChooser.vue'
import RallyRoundBackgroundImageChooser from '@/components/admin/RallyRoundBackgroundImageChooser.vue'
import RallyRoundVoucherChooser from '@/components/admin/RallyRoundVoucherChooser.vue'
import RallyRoundLiveSettings from '@/components/admin/RallyRoundLiveSettings.vue'
// import RallyRoundDownloader from '@/components/admin/RallyRoundDownloader.vue'
import BacAlert from '@/components/BacAlert.vue'
import BacLazyImage from '@/components/BacLazyImage.vue'

@Component({
  components: {
    BaseButtons,
    RallyChallengeChooser,
    ChallengeStatistics,
    RallyPictureChooser,
    RallyRoundDefaultTeamlogoChooser,
    BacAlert,
    BacLazyImage,
    RallyRoundBackgroundImageChooser,
    RallyRoundVoucherChooser,
    RallyRoundLiveSettings
    //    RallyRoundDownloader
  }
})
export default class RallyRound extends Vue {
  get rallyRound () {
    return this.$store.state.PageURLRallyRound.rallyRound
  }
}

